<template>
  <div v-if="AKPriceSOTODifferentPercent">
    <feather-icon
      :id="`IAmAlertAKPriceSOTODifferentPercent-${uid}`"
      icon="InfoIcon"
      :size="iconSize"
      :class="`text-warning cursor-pointer ${svgClass}`"
    />

    <b-tooltip
      :target="`IAmAlertAKPriceSOTODifferentPercent-${uid}`"
      triggers="hover focus"
      boundary="window"
      custom-class="tooltip_class"
      variant="light"
    >
      <span class="fw-700">
        <!--
        Đối với các vé SOTO của AK, giá net sẽ chênh {{ AKPriceSOTODifferentPercent }}% so với thực tế do tỷ giá ngoại tệ.
        Giá sẽ được điều chỉnh lại chính xác trên báo cáo bán sau khi hãng thu
        -->
        {{ $t(`flight.AKPriceSOTODifferentPercent`, { AKPriceSOTODifferentPercent }) }}
      </span>
    </b-tooltip>
  </div>
</template>

<script>
import { BTooltip } from 'bootstrap-vue'
import { computed } from '@vue/composition-api'
import { v4 as uuidv4 } from 'uuid'

import store from '@/store'

export default {
  name: 'IAmAlertAKPriceSOTODifferentPercent',
  components: {
    BTooltip,
  },
  props: {
    svgClass: {
      type: String,
      default: '',
    },
    iconSize: {
      type: String,
      default: '16',
    },
  },
  setup() {
    const AKPriceSOTODifferentPercent = computed(() => store.getters['globalConfig/getAKPriceSOTODifferentPercent'])
    const uid = uuidv4()
    return {
      AKPriceSOTODifferentPercent,
      uid,
    }
  },
}
</script>

<style lang="scss">
.tooltip_class {
  .arrow::before {
    border-top-color: #f0ad4e !important;
    border-bottom-color: #f0ad4e !important;
  }
  .tooltip-inner {
    border: 1px solid #f0ad4e !important;
  }
}
</style>
